import { render, staticRenderFns } from "./zhUser.vue?vue&type=template&id=2084b4fd&scoped=true&"
import script from "./zhUser.vue?vue&type=script&lang=js&"
export * from "./zhUser.vue?vue&type=script&lang=js&"
import style0 from "./zhUser.vue?vue&type=style&index=0&id=2084b4fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084b4fd",
  null
  
)

export default component.exports